import { ChangeEvent, useCallback } from 'react';

export function useComputeInputFieldHandleChange(
  onChange: (...event: any[]) => void,
  filterValue?: (val: unknown) => boolean,
  onChangeCallback?: (...event: any[]) => any,
) {
  const isHtmlChangeEvent = (e: unknown): e is ChangeEvent<HTMLInputElement> =>
    e != null && typeof e === 'object' && 'target' in e;

  const handleChange = useCallback(
    (e: unknown) => {
      if (typeof onChangeCallback === 'function') {
        return onChange(onChangeCallback(e));
      }
      return onChange(e);
    },
    [onChange, onChangeCallback],
  );

  return useCallback(
    (e: unknown) => {
      if (typeof filterValue === 'function') {
        if (isHtmlChangeEvent(e) && filterValue(e.target.value))
          handleChange(e);
        else if (filterValue(e)) handleChange(e);
      } else handleChange(e);
    },
    [filterValue, onChange, onChangeCallback],
  );
}
